module.exports = __webpack_public_path__ + "img/公司大楼.b1795fde.png";